/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Controller } from '../utils/controller';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    FS: any;
  }
}


const waitUntil = (
  assertion: () => boolean,
  options: {
    timeout: number;
  }
): Promise<void> => {
  const start = Date.now();
  return new Promise((resolve, reject) => {
    const interval = setInterval(() => {
      if (Date.now() - start > options.timeout) {
        clearInterval(interval);
        reject(new Error('Timeout Exceeded.'));
      }
      if (assertion()) {
        clearInterval(interval);
        resolve();
      }
    }, 100);
  });
};

export default class extends Controller {
  static targets = ['values'];
  declare valuesTarget: HTMLDivElement;
  public connect() {
    // Set the user agent when the component mounts
    this._setUserAgent();
    this._setHost();
    this._pollForFullStorySessionURL();
  }

  private async _pollForFullStorySessionURL(): Promise<void> {
    // initialize with loading state
    this._setFullStorySessionURL('Loading...');

    try {
      await waitUntil(() => window.FS?.getCurrentSessionURL?.() != null, {
        timeout: 8000
      });
      this._setFullStorySessionURL(window.FS?.getCurrentSessionURL?.());
    } catch (err) {
      const errMsg = 'Cannot retrieve FullStory session URL.';
      this._setFullStorySessionURL(errMsg);
    }
  }

  private _setFullStorySessionURL(content: string): void {
    // Set the FullStory session URL when the component mounts
    const sessionURLElement = this.element.querySelector('#fs-session-url');
    if (sessionURLElement) {
      sessionURLElement.textContent = content;
    }
  }

  private _setUserAgent(): void {
    const userAgentElement = this.element.querySelector('#user-agent');
    if (userAgentElement) {
      userAgentElement.textContent = navigator.userAgent;
    }
  }

  private _setHost(): void {
    const target = this.element.querySelector('#host');
    if (target) {
      target.textContent = window.location.hostname;
    }
  }

  public copy(event) {
    event.preventDefault();
    let textContent = this.valuesTarget.textContent ?? '';

    // Remove extra newlines and spacing
    textContent = textContent.replace(/\s*\n\s*/g, '\n').trim();

    navigator.clipboard.writeText(textContent);
  }
}
